<template>
    <div class="solve">
        <div class="solve-banner">
            <img src="../../../assets/images/banner2.jpg" alt="">
        </div>
        <div class="solve-main">
            <!-- 面包屑 -->
            <Breadcrumb separator=">" class="nav_roter">
                <Breadcrumb-item><router-link to="/skill">产品方案</router-link></Breadcrumb-item>
                <Breadcrumb-item><router-link to="/client">方案案例</router-link></Breadcrumb-item>
                <Breadcrumb-item>应用案例</Breadcrumb-item>
            </Breadcrumb>
            <!-- 下方内容 -->
            <div class="all_cont">
                <!-- 左侧 -->
                <div class="left_solve">
                    <p class="title_li">应用案例</p>
                    <ul>
                        <li id="tabs-list">四川省智慧公共安全系统</li>
                        <li id="tabs-list">雪亮工程</li>
                        <li id="tabs-list"  class="active-list">青岛高清视频传输</li>
                        <li id="tabs-list">北京市建委环境检测</li>
                        <li id="tabs-list">IDC机房监控系统</li>
                        <li id="tabs-list">新疆公安局信息封控视频溯源</li>
                    </ul>
                </div>
                <!-- 右侧 -->
                <div class="right_solve">
                    <!-- 第一个 四川公共安全 -->
                    <div id="right_boxs" class="solve_alllist hide">
                        <p class="top_title">四川省智慧公共安全系统</p>
                        <div class="mid-title">项目背景</div>
                        <p style="text-indent: 2em">四川省某市智慧公共安全系统为新建平安城市项目的子系统，实现城市监控系统的全部覆盖与数据中心的统一管理。实现对3200路摄像机生成数据的实时传回，并于数据中心完成存储。</p>
                        <div class="mid-title">项目需求</div>
                        <p style="text-indent: 2em">3200路1080P高清视频云存储扩容</p>
                        <p style="text-indent: 2em">存储时长由1个月增加到3个月</p>
                        <div class="mid-title">方案设计</div>
                        <p style="text-indent: 2em">VDMS系统通过国标GB/T 28181对接到现有监控系统，在不改变视频分辨率、帧率、时长的情况下将视频压缩至原来的1/10，在不增加存储设备的同时，实现3200路交警队1080P高清视频180天存储，压缩后视频不影响二次使用、结构化分析，通过第三方平台可以无缝调用。</p>
                        <div class="mid_img"><img src="../../../assets/images/128.png" alt=""></div>
                        <div class="mid-title">客户价值</div>
                        <div class="bott_box">
                            <p class="bottom_title">高效存储</p>
                            <p>VDMS系统能够在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行压缩存储管理，平均可以节省10倍以上的存储空间，大幅降低存储要求。</p>
                            <ul>
                                <li><span></span>节省资源 降低成本
                                    <p>VDMS视频数据管理系统可以将视频数据无损压缩到原视频的1/10大小，减少存储容量和存储设备，可以大幅降低机房的建设成本。 </p>
                                </li>
                                <li><span></span>节省机柜 减少空间占用
                                    <p>VDMS系统硬件采用的都是标准2U刀片式服务器，减少存储占用机房空间的同时进一步提升空间利用率，有效节省 机柜数量。</p>
                                </li>
                                <li><span></span>减少硬盘损耗 节约维护成本
                                    <p>在实际项目应用中，硬盘每年都有一定的损坏率，最高甚至达到10%以上，这会增加后期的运维成本。通过VDMS 系统与存储配合应用，在保证所有视频画质清晰的同时大量减少硬盘数量，大幅降低每年硬盘更换数量，节约维护 成本。VDMS系统运行稳定，有效降低人员成本。</p>
                                </li>
                            </ul>
                            <p class="bottom_title">绿色低能耗</p>
                            <p>42U标准机柜能耗极低，全功≤1000W；待机≤200W</p>
                        </div>
                    </div>
                    <!-- 第二个 雪亮工程-->
                    <div id="right_boxs" class="solve_alllist hide">
                        <p class="top_title">雪亮工程</p>
                        <div class="mid-title">项目背景</div>
                        <p style="text-indent: 2em">以公共视频监控全覆盖为工作重点“雪亮工程”，即公共安全视频监控建设联网应用，是一项以“全域覆盖、全网共享、全时可用、全程可控”为总目标的惠民工程。</p>
                        <div class="mid-title">项目需求</div>
                        <p style="text-indent: 2em">6000路1080P公共安全高清摄像头，计划不改原存储容量，将视频数据存储天数由40天增加到90天。</p>
                        <div class="mid-title">方案设计</div>
                        <p style="text-indent: 2em">在本项目中，使用VDMS存储方案，对6000路高清视频存储90天只占用2870TB存储空间。</p>
                        <div class="mid_img"><img src="../../../assets/images/152.png" alt=""></div>
                        <div class="mid-title">客户价值</div>
                        <div class="bott_box">
                            <p class="bottom_title">高效存储</p>
                            <p>VDMS系统能够在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行压缩存储管理，平均可以节省10倍以上的存储空间，大幅降低存储要求。</p>
                            <ul>
                                <li><span></span>节省资源 降低成本
                                    <p>VDMS视频数据管理系统可以将视频数据无损压缩到原视频的1/10大小，减少存储容量和存储设备，可以大幅降低机房的建设成本。 </p>
                                </li>
                                <li><span></span>节省机柜 减少空间占用
                                    <p>VDMS系统硬件采用的都是标准2U刀片式服务器，减少存储占用机房空间的同时进一步提升空间利用率，有效节省 机柜数量。</p>
                                </li>
                                <li><span></span>减少硬盘损耗 节约维护成本
                                    <p>在实际项目应用中，硬盘每年都有一定的损坏率，最高甚至达到10%以上，这会增加后期的运维成本。通过VDMS 系统与存储配合应用，在保证所有视频画质清晰的同时大量减少硬盘数量，大幅降低每年硬盘更换数量，节约维护 成本。VDMS系统运行稳定，有效降低人员成本。</p>
                                </li>
                            </ul>
                            <p class="bottom_title">绿色低能耗</p>
                            <p>42U标准机柜能耗极低，全功≤1000W；待机≤200W</p>
                        </div>
                    </div>
                    <!-- 第三个 青岛中石油传输 -->
                    <div id="right_boxs" class="solve_alllist">
                        <p class="top_title">青岛高清视频传输</p>
                        <div class="mid-title">项目背景</div>
                        <p style="text-indent: 2em">为保障青岛上合峰会顺利进行，某央企公司青岛分部要求所有业务网点视频监控系统进行存储升级改造，采集的视频图像信息保存期限不得少于九十日。</p>
                        <div class="mid-title">项目需求</div>
                        <p style="text-indent: 2em">某央企公司青岛分部提出了实时视频无损压缩、延时90天存储、总部调看不卡顿三项需求。</p>
                        <div class="mid-title">方案设计</div>
                        <p style="text-indent: 2em">了解了青岛市各个业务网点的基础网络情况，提出了基于VDMS-T-1-A的实时压缩解决方案。目前在各个业务网点已经实现视频数据透明传输，视频码流压缩5倍，存储时长达到90天。</p>
                        <div class="mid_img"><img src="../../../assets/images/153.png" alt=""></div>
                        <div class="mid-title">客户价值</div>
                        <div class="bott_box">
                            <p class="bottom_title">高效存储</p>
                            <p>VDMS-T-1能够在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行传输，平均可以节省10倍以上的传输带宽，大幅降低网络需求。</p>
                            <ul>
                                <li><span></span>透明传输
                                    <p>VDMS-T-1可以将视频数据无损压缩到原视频的1/10大小再进行传输，同时支持标准H.264、H.265等标准协议，可以无缝对接到现有监控系统。</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 第四个 北京市建委-->
                    <div id="right_boxs" class="solve_alllist hide">
                        <p class="top_title">北京市建委环境检测</p>
                        <div class="mid-title">项目背景</div>
                        <p style="text-indent: 2em">北京市建委要求住建系统监管的建设工地视频按要求接入视频监管工作平台，该监控装置可实时查看掌握建设工地治安、安全文明施工、停工整改等情况。</p>
                        <div class="mid-title">项目需求</div>
                        <p style="text-indent: 2em">由于建委各项目基地作业分散且网络建设多为4G，因此，就存在低带宽、不稳定、费用高，以及画面传输质量差的问题，无法实现基于无线网络将视频数据传回建委总部的效果，导致监控体验不佳，影响监控效果。</p>
                        <div class="mid-title">方案设计</div>
                        <p style="text-indent: 2em">通过VDMS系统，前端基于VDMS-T-1-A实现实时压缩，然后，通过4G网络将BBW格式文件传输到VDMS服务器，最终可呈现高达1080P的高清画面。</p>
                        <div class="mid_img"><img src="../../../assets/images/149.png" alt=""></div>
                        <div class="mid-title">客户价值</div>
                        <div class="bott_box">
                            <p class="bottom_title">高效存储</p>
                            <p>VDMS-T-1能够在不影响原有视频画质，不改变原有视频帧率、视频率、时长的前提下对视频数据进行传输，平均可以节省10倍以上的传输带宽，大幅降低网络需求。</p>
                            <ul>
                                <li><span></span>透明传输
                                    <p>VDMS-T-1可以将视频数据无损压缩到原视频的1/10大小再进行传输，同时支持标准H.264、H.265等标准协议，可以无缝对接到现有监控系统。   </p>
                                </li>
                                <li><span></span>4G传输
                                    <p>VDMS-T-1将视频数据无损压缩到原视频的1/10大小再通过4G传输，解决工地无网络、高清视频无法传输的问题。</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 第五个 IDC机房 -->
                    <div id="right_boxs" class="solve_alllist hide">
                        <p class="top_title">IDC机房监控系统</p>
                        <div class="mid-title">项目背景</div>
                        <p style="text-indent: 2em">IDC机房视频监控系统是基于现代控制理论中的分布控制理论而设计的一个集散型控制系统，它通过中心设备将分布在监控现场的各个智能单元连接在一起，构成一个先进而完善的综合监控系统，为IDC机房提供一个安全、高效、智能的环境。</p>
                        <div class="mid-title">项目需求</div>
                        <p style="text-indent: 2em">IDC机房一期改造涉及现接入1400路摄像头，将IDC机房的1400路IP摄像头录像存储10天，扩容到90天。</p>
                        <div class="mid-title">方案设计</div>
                        <p style="text-indent: 2em">在原有的监控视频系统架构和设备后端接入VDMS视频压缩产品设备，在不增加存储设备的情况下，实现1400路IPC存储到90天。</p>
                        <div class="mid_img"><img src="../../../assets/images/151.png" alt=""></div>
                        <div class="mid-title">客户价值</div>
                        <div class="bott_box">
                            <p class="bottom_title">高效存储</p>
                            <p>VDMS系统能够在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行压缩存储管理，平均可以节省10倍以上的存储空间，大幅降低存储要求。</p>
                            <ul>
                                <li><span></span>节省资源 降低成本
                                    <p>VDMS视频数据管理系统可以将视频数据无损压缩到原视频的1/10大小，减少存储容量和存储设备，可以大幅降低机房的建设成本。 </p>
                                </li>
                                <li><span></span>节省机柜 减少空间占用
                                    <p>VDMS系统硬件采用的都是标准2U刀片式服务器，减少存储占用机房空间的同时进一步提升空间利用率，有效节省 机柜数量。</p>
                                </li>
                                <li><span></span>减少硬盘损耗 节约维护成本
                                    <p>在实际项目应用中，硬盘每年都有一定的损坏率，最高甚至达到10%以上，这会增加后期的运维成本。通过VDMS 系统与存储配合应用，在保证所有视频画质清晰的同时大量减少硬盘数量，大幅降低每年硬盘更换数量，节约维护 成本。VDMS系统运行稳定，有效降低人员成本。</p>
                                </li>
                            </ul>
                            <p class="bottom_title">绿色低能耗</p>
                            <p>42U标准机柜能耗极低，全功≤1000W；待机≤200W</p>
                        </div>
                    </div>
                    <!-- 第六个 新疆公安局 -->
                    <div id="right_boxs" class="solve_alllist hide">
                        <p class="top_title">新疆公安局信息封控视频溯源</p>
                        <div class="mid-title">项目背景</div>
                        <p style="text-indent: 2em">在刑侦案件中，视频作为一种极为有效的破案辅助工具，极大地提高了成功破案和定罪的概率，是配合公安司法部门打击犯罪、维护社会稳定的重要手段。然而，视频失泄密事件屡有发生，人为的窃密和传播为警务工作带来极为不利的影响。</p>
                        <div class="mid-title">项目需求</div>
                        <p style="text-indent: 2em">视频网内视频源实时水印渲染，防止视频盗用、盗录。一旦视频泄露到互联网上，可通过该溯源系统快速倒查视频图像泄露源头</p>
                        <div class="mid-title">方案设计</div>
                        <p style="text-indent: 2em">可通过第三方平台客户端在任何终端电脑登录，水印服务器会全方位记录登录终端的MAC、IP地址及用户登录和访问的时间信息生成视频水印，以二维码等形式实时嵌入至获取的视频流图像中，实现低延迟、高稳定性和可靠性的视频流处理传输，并满足一定规模的并发访问调用视频需求。</p>
                        <div class="mid_img"><img src="../../../assets/images/145.png" alt=""></div>
                        <div class="mid-title">客户价值</div>
                        <div class="bott_box">
                            <p>解决云端视频数据来源无法追溯的问题，有效查找泄露视频来源，及时控制不利影响，为信息封控提供有利的技术支持。</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from "../../../../node_modules/jquery/dist/jquery.js";
export default {
    mounted:function(){
        $(".left_solve li").click(function () {
            $(".right_solve #right_boxs").eq($(this).index()).removeClass("hide").siblings().addClass("hide");
            $('.left_solve #tabs-list:nth-child(1)').removeClass("active-list");
            $(".left_solve #tabs-list").eq($(this).index()).addClass("active-list").siblings().removeClass("active-list");
        })
    },
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
    .solve {
        width: 100%;
        background: #f0fcfd;
        color: #333333;
    }
    .solve-banner {
        width: 100%;
    }
    .solve-banner img {
        width: 100%;
    }

     /* 应用案例内容 */
    .solve-main {
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;
        /* margin-bottom: 65px;  */
    }

    /* 面包屑 */
    .nav_roter {
        font-size: 18px;
        margin-top: 10px;
    }
    .ivu-breadcrumb-item-link {
        color: #333333;
    }

    /* 下方内容 */
    .all_cont {
        margin-top: 48px;
    }
    /* 左侧 */
    .left_solve {
        width: 286px;
        float: left;
    }

    .left_solve li {
        list-style: none;
        font-size: 18px;
        color: #333333;
        height: 50px;
        border-bottom: solid #dddddd 1px;
        line-height: 50px;
        padding-left: 23px;
        cursor: pointer;
        margin-top: 0px;
    }
     .left_solve li:nth-child(1) {
        border-top: 1px solid #dddddd;
     }
    .left_solve .title_li {
        font-size: 24px;
        padding: 0;
        margin-bottom: 10px;
    }


    .left_solve .active-list {
        color: #29b3de;
    }

    /* 右侧 */
    .right_solve {
        width: 902px;
        background:  #fbfbfb;
        word-break: break-all;
        padding-bottom:2000px;
        margin-bottom:-1990px;
        float: right;
    }

    /* 第一个内容 */
    .solve_alllist {
        padding: 12px 24px;
    }
    .solve_alllist p {
        font-size: 18px;
        color: #666666;
    }
    /* 标题 */
    .solve_alllist .top_title {
        font-size: 36px;
        color: #000;
        text-align: center;
    }
    .solve_alllist .mid-title {
        width: 208px;
        height: 40px;
        font-size: 24px;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 10px;
        padding-left: 5px;
        margin-top: 40px;
    }
    /* 中间图片 */
    .solve_alllist .mid_img {
        width: 714px; 
        height: 430px;
        margin: 0 auto; 
        border: 1px solid #ddd; 
        margin-top: 30px; 
    }
    .solve_alllist .mid_img img {
        width: 100%;
        height: 100%;
    }
    /* 下方文字 */
    /* 795, 48 */
    .solve_alllist .bott_box {
        width: 795px;
        margin-left: 48px;
    }
    .bott_box p {
        margin-left: 24px;
        margin-bottom: 20px;
    }
    .bott_box .bottom_title {
        font-size: 18px;
        color: #000;
        font-weight: 700;
        margin-bottom: 25px;
        margin-left: 0;
    }
    
    .bott_box li {
        list-style: none;
        font-size: 18px; 
        color: #666666;
    }
    .bott_box li span {
         display: block;
         width: 13px;
         height: 13px;
         background: #000000;
         border-radius: 50%;
         float: left;
         margin-right: 13px;
         margin-top: 8px;
    }

    .hide {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/solve/sanne/sanne.vue